import { UpsellItem } from './UpsellItem';

export class Item {
    items: Array<UpsellItem>;
}
